<template>
<div>
  <div v-if="!isLoaded">
    <progress-ring radius="60" :progress="progress" stroke="4"></progress-ring>
  </div>

  <div v-if="isLoaded">
  <div class="row">
      <div class="sixty">
        <div class="envn" style="margin-left:10px">
        <div id="example-banner">
          <h3>
          <a href="/#/sign-up">
          This is an example of an architectural decision that you could create using the Slate
          </a>
          </h3>
        </div>

        <h2>{{ spec.SPEC.title }}</h2>

        <table>
          <tr>
            <th>Status</th>
            <th>Author</th>
            <th>Updated</th>
          </tr>
          <tr>
            <td>
              <div :class="'box ' + spec.SPEC.status"><h3>{{ spec.SPEC.status | capitalize }}</h3></div>
            </td>
            <td><h3><Avatar
                size=40
                variant="beam"
                :name="spec.SPEC.author"
                :colors="colors"
              /> {{ spec.SPEC.author }}</h3></td>
            <td><h3>{{ spec.SPEC.updated_on | date }}</h3></td>
          </tr>
        </table>

        <h2>Summary</h2>
        <p>{{ spec.SPEC.summary }}</p>

        <h2>Context</h2>
        <vue-markdown :source="spec.SPEC.context"></vue-markdown>

        <h2>Decision</h2>
        <vue-markdown :source="spec.SPEC.decision"></vue-markdown>

        <h2>Consequences</h2>
        <vue-markdown :source="spec.SPEC.consequences"></vue-markdown>
      </div>
      </div>

      <div class="thirty" style="padding-top:40px; margin-left:auto; background-color:#fff">
        <router-link :to="{ name: 'sign-up'}" tag="button" style="margin-right:20px">Sign up to create a architectural decision just like this!</router-link>

        <div v-if="spec.SPEC.contributors.length > 1" class="contributors">
        <h3 style="margin-left:20px">Contributors</h3>
        <ul>
          <li v-for="person in spec.SPEC.contributors" v-if="person != spec.SPEC.author">
            <Avatar
                size=40
                :name="person"
                :colors="colors"
              />
            {{ person }}</li>
        </ul>
        </div>

        <div v-if="spec.VERSION">
        <h3 style="margin-left:20px">Versions</h3>
        <ol>
          <li v-for="spec in spec.VERSION">Version #{{ spec.version }}  - {{ spec.updated_on | date }}</li>
        </ol>
        </div>

        <div v-if="spec.SPEC.services.length">
        <h3 style="margin-left:20px">Associated Services</h3>
        <ul>
          <li v-for="service in spec.SPEC.services"><router-link :to="{ name: 'example-service', params: { id: service.id }}">{{ service.serviceName}}</router-link></li>
        </ul>
      </div>
      </div>

  </div>
  <div class="row" v-for="comment in spec.COMMENTS">
    <div class="sixty">
      <div class="envn" style="margin-left:10px">
        <div class="activity comment" id="#comment-UUID">
          <div class="comment-info row">
            <div class="sixty">
            <h3><Avatar
                size=40
                :name="comment.author"
                :colors="colors"
              /><strong>{{ comment.author }}</strong> commented <time :datetime="isoDate(comment.updated_on)">{{ comment.updated_on | timeAgo }}</time></h3>
            </div>
            <div class="thirty" style="text-align:right">
              <p style="margin-top:0;">
              <span v-if="spec.SPEC.author == comment.author">Author</span>
              </p>
            </div>
          </div>
          <div class="comment-message">
            <vue-markdown :source="comment.comment"></vue-markdown>
          </div>
        </div>
      </div>
    </div>
  </div>

  </div>
</div>
</template>

<script>
import VueMarkdown from 'vue-markdown'
import ProgressRing from '@/components/progress-ring.vue'
import Avatar from "@/components/avatar.vue";

export default {
  name: 'spec-example',
  components: {
    ProgressRing,
    VueMarkdown,
    Avatar
  },
  data: function () {
    return {
      isLoaded: false,
      colors: ['#CBE6DD','#F2E9E6','#061B26','#FF416C','#C7D3EB'],
      progress: 0,
      spec: null,
      html: {
        title: null
      },
      spec: {
        VERSION: [
          {
          version: 1,
          updated_on: new Date(new Date().setMonth(new Date().getMonth()-3)).getTime()
          },
          {
          version: 2,
          updated_on: new Date(new Date().setMonth(new Date().getMonth()-2)).getTime()
          },
          {
          version: 3,
          updated_on: new Date(new Date().setMonth(new Date().getMonth()-1)).getTime()
          }
        ],
        SPEC: {
          title: "Support ISO timestamps",
          author: "Pete",
          summary: "Services should support ISO timestamps",
          context: "When people are considering signing up, they would like to see what the Slate is offering. \n\nWe could show them a _screenshot_, but this seems like a better fit",
          decision: "We create a mock version of an architectural decision and see what people think.",
          consequences: "People will see example what an architectural decision will look like. It might even encourage them to [sign up!](/#/sign-up)",
          status: 'accepted',
          version: 4,
          updated_on: Date.now().toString(),
          services: [
            {
              serviceName: "Galactus",
              id: "3d63e602-a084-11eb-ac96-a3dc34cea142"
            },
            {
              serviceName: "Entropy Khaos Service (EKS)",
              id: "3fa1743e-a084-11eb-892a-4713a7ea79d7"
            },
            {
              serviceName: "Omega Star",
              id: "400943fc-a084-11eb-84e8-37f16b167d93"
            },
            {
              id: "3b92c528-a084-11eb-85e2-d35589403759",
              serviceName: "Papaya"
            },
            {
              id: "3bf53366-a084-11eb-bac1-df7fd66ae57d",
              serviceName: "Magic Baby (MBS)"
            },
            {
              id: "3cb2da74-a084-11eb-912a-ef64f8062a41",
              serviceName: "Racoon"
            },
            {
              id: "3d0be8f8-a084-11eb-9849-77a5f2b364ed",
              serviceName: "Wingman"
            },
            {
              id: "3a061624-a084-11eb-adbd-b36f39692425",
              serviceName: "Bingo Service"
            },
            {
              id: "3dc05be4-a084-11eb-9fbc-c74059d0c2ee",
              serviceName: "RGS"
            },
            {
              id: "3e14e362-a084-11eb-acba-6f89fb871034",
              serviceName: "BRB-DLL"
            },
            {
              id: "3e7b9788-a084-11eb-887a-bb8dbd9c82dc",
              serviceName: "Ringo2"
            },
            {
              id: "3ed8f75c-a084-11eb-a9eb-d3225360f750",
              serviceName: "🌻 BLS"
            },
            {
              id: "3f399bde-a084-11eb-8dcc-7b6ddaee62bb",
              serviceName: "Birthday Boy"
            },
          ],
          contributors: ["Dave", "Lisa", "Paul", "Jo"]
        },
        COMMENTS: {
          "747e76e4-a128-11eb-8271-d71c0769a4d4": {
          "comment": "**We're blocked on [Birthday boy](/#/example/services/3f399bde-a084-11eb-8dcc-7b6ddaee62bb)!**\n\n[Omega Star](/#/example/services/400943fc-a084-11eb-84e8-37f16b167d93) still doesn't support ISO timestamps like they said they would, like a month ago.\n\n\nAnd without [Wingman](/#/example/services/3d0be8f8-a084-11eb-9849-77a5f2b364ed) not being able to talk to anyone [I'll never find true love and die alone](https://www.youtube.com/watch?v=y8OnoxKotPQ).",
          "hasRendered": false,
          "id": "747e76e4-a128-11eb-8271-d71c0769a4d4",
          "author": "Dave",
          "updated_on": "1618748744875"
        }
      },
      }
    }
  },
  metaInfo () {
    return {
      title: "A example of an architectural decision"
    }
  },
  created() {
    this.fetch();
  },
  mounted() {
    (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:2330268,hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
  },
  methods: {
    async fetch() {
      const interval = setInterval(() => {
        this.progress += 1;
        if (this.progress === 100)
          clearInterval(interval);
      }, 100);
      this.isLoaded = true;
    },
    isoDate: function(cdate) {
      if (!cdate) return '';
      var d = new Date(parseInt(cdate));
      return d.toISOString();
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    date: function(cdate) {
      if (!cdate) return '';
      var d = new Date(parseInt(cdate));
      return d.toDateString();
    },
    timeAgo: function(someDateInThePast) {
     var result = '';
     var difference = Date.now() - someDateInThePast;
     if (difference < 5 * 1000) {
         return 'just now';
     } else if (difference < 90 * 1000) {
         return 'moments ago';
     }
     //it has minutes
     if ((difference % 1000 * 3600) > 0) {
       if (Math.floor(difference / 1000 / 60 % 60) > 0) {
         let s = Math.floor(difference / 1000 / 60 % 60) == 1 ? '' : 's';
         result = `${Math.floor(difference / 1000 / 60 % 60)} minute${s} `;
       }
     }
     //it has hours
     if ((difference % 1000 * 3600 * 60) > 0) {
       if (Math.floor(difference / 1000 / 60 / 60 % 24) > 0) {
         let s = Math.floor(difference / 1000 / 60 / 60 % 24) == 1 ? '' : 's';
         result = `${Math.floor(difference / 1000 / 60 / 60 % 24)} hour${s} `;
       }
     }
     //it has days
     if ((difference % 1000 * 3600 * 60 * 24) > 0) {
       if (Math.floor(difference / 1000 / 60 / 60 / 24) > 0) {
         let s = Math.floor(difference / 1000 / 60 / 60 / 24) == 1 ? '' : 's';
         result = `${Math.floor(difference / 1000 / 60 / 60 / 24)} day${s} `;
       }
     }
     return result + ' ago';
    },
  }
}
</script>
<style>
.contributors ul {
  list-style: none;
  padding-inline-start: 20px;
}
</style>
